export enum PaymentStatusEnum {
  Pending,
  Paid,
  Refused,
  Settled,
}
